//------------------ Raw Exam Data - start------------------//
import { call, fork, put, takeEvery } from 'redux-saga/effects';

import * as types from './rawExamDataActionType';
import * as actions from './rawExamDataActions';
import * as services from './rawExamDataServices';

function* fetchRawExamDataSaga(action) {
    try {
        const response = yield call(services.getAllRawExamData, action.payload);
        if (!response) {
            throw new Error('No response received from API');
        }
        yield put(actions.fetchRawExamDataSuccess(response?.values));
    } catch (error) {
        let errorMessage = 'Failed to fetch raw exam data.';
        console.error('Raw Exam Data API Error:', {

            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });
        yield put(actions.fetchRawExamDataFailure(errorMessage));
    }
}

// Watcher Saga
export default function * watchRawExamDataSaga() {
    yield takeEvery(types.FETCH_RAW_EXAM_DATA_REQUEST, fetchRawExamDataSaga);
}